<template>
  <!-- XXX  duplicated w/ src/components/Widgets/AdminReports/AdminSalesSummary.vue? -->
  <base-card class="px-4 pt-3 pb-2 sales-widget">
    <base-heading>Sales Overview</base-heading>
    <hr style="border-color: #646464">
    <base-loading :show="loading" />
    <div
      v-if="!loading"
      class="d-flex justify-content-between mt-4 stats-container"
    >
      <div
        v-for="(entry, index) in entries"
        :key="`stat_${index}`"
        :class="`w-100 text-center py-2 ${index < entries.length - 1 ? 'divider' : ''}`"
      >
        <base-text
          class="label"
          light
        >
          {{ entry.label }}
        </base-text>
        <base-text
          class="value"
          medium
        >
          {{ formatReportValue(entry) }}
        </base-text>
      </div>
    </div>
  </base-card>
</template>

<script>
import utilsMixin from '@/_utilities/utilsMixin';

export default {
  name: 'SalesSummary',
  mixins: [utilsMixin],
  props: {
    entries: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {

  },
};
</script>
<style scoped lang="scss">

.divider { border-right: solid 1px #64646480; }
.label { font-size: 15px; letter-spacing: -0.082px; }
.sales-widget { background-color: #F8E6D8; }
.value { font-size: 17px; }

</style>
